/** Russian default zod messages for every schema (decisions-log V45); imported once at startup. */
import { z } from 'zod';

z.config(z.locales.ru());
